import { useState, useEffect } from 'react';
import fetchWithTenant from '../utils/fetchWithTenant';

// CredentialPicker (868m2a981): shared credential-selection <select>,
// extracted from MdDiscoveryDeviceDetail.jsx's OnvifPromotion sub-component,
// which had this exact fetch/filter/render pattern inlined and page-local.
// Fetches the tenant's vault credentials for one protocol; an empty value
// means "use the integration/tenant default", never auto-selected.
export default function CredentialPicker({ protocol, value, onChange, className, style, disabled, title, defaultLabel = 'Use integration default' }) {
  const [creds, setCreds] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetchWithTenant('/api/md/credentials');
        const data = await res.json();
        if (cancelled) return;
        setCreds((data.data || []).filter((c) => c.protocol === protocol));
      } catch (err) {
        console.error('Failed to load credentials:', err);
      }
    })();
    return () => { cancelled = true; };
  }, [protocol]);

  return (
    <select
      className={className || 'dd-input'}
      style={style}
      disabled={disabled}
      title={title}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">{defaultLabel}</option>
      {creds.map((c) => (
        <option key={c.id} value={c.id}>
          {c.label}{c.isDefault ? ' (default)' : ''}
        </option>
      ))}
    </select>
  );
}
